//
//
//
//
//
//
//
//

export default {
  name: 'app-view-item-image',

  props: ['label', 'value'],

  computed: {
    isBlank() {
      return !this.value || !this.value.length;
    },
  },
};
